// extracted by mini-css-extract-plugin
export default {"body":"ConfirmDialog_body__-1hTp","actions":"ConfirmDialog_actions__aIoNE"};